/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/components';
import { isRTL } from '@gechiui/i18n';

const NavigateUp = () => (
	<SVG
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<Path fill="none" d="M0 0h24v24H0V0z" />
		<Path
			fill="white"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17,11  z L15.58,12.42 L12,8.83 L12,18 L22,18 L22,20 L10,20 L10,8.83 L6.42,12.42 L5,11 L11,5 L17,11"
			transform={ isRTL() ? 'scale(-1,1) translate(-24,0)' : undefined }
		/>
	</SVG>
);

export default NavigateUp;
